import React from 'react';

import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { TENANT_ID } from 'global/constants';

import { isExternal } from 'utils/UrlUtil';
import { getTenantId } from 'utils/tenantUtil';

import './css/Subnav.sass';

export const SubnavButton = ({ link, name, clickCookieDisclaimer }) => {
  const handleOnClick = () => {
    if (name === 'Cookie Disclaimer') {
      clickCookieDisclaimer();
    }
  };

  const getName = () => {
    if (name === 'Cookie Disclaimer') {
      return getTenantId() === TENANT_ID.AVA ? 'Cookie Einstellungen' : 'Cookie Disclaimer';
    }

    return name;
  };

  return isExternal(link) ? (
    <a href={link} className="subnav-button-wrapper">
      <button onClick={handleOnClick} className="subnav-button">
        {getName()}
      </button>
    </a>
  ) : (
    <Link to={{ pathname: link }} className="subnav-button-wrapper">
      <button onClick={handleOnClick} className="subnav-button">
        {getName()}
      </button>
    </Link>
  );
};
// link is optional because it is not required for the cookie disclaimer button
SubnavButton.propTypes = {
  link: PropTypes.string,
  name: PropTypes.string.isRequired,
  clickCookieDisclaimer: PropTypes.func,
};

SubnavButton.defaultProps = {
  link: undefined,
  clickCookieDisclaimer: () => {},
};
